import { AxiosError } from "axios";

export function getResponseError(ex: unknown): Error {
  if (ex instanceof AxiosError) {
    return new Error(ex.response?.data?.title ?? ex.message);
  } else if (typeof ex === "string") {
    return new Error(ex);
  } else if (ex instanceof Error) {
    return ex;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return new Error((ex as any)?.message ?? "Error");
}
